export const printConfig = numDoc => [
  'Введите номер договора, по умолчанию подставляется последний + 1, согласно текущей нумерации',
  'Подтверждение',
  {
    confirmButtonText: 'Скачать документ для печати',
    cancelButtonText: 'Закрыть',
    inputValue: numDoc,
  },
]

export const taxationOptions = [
  { value: 'not_stated', label: 'не указан' },
  { value: 'used', label: 'с НДС 20%' },
  { value: 'used_22', label: 'с НДС 22%' },
  { value: 'used_5', label: 'с НДС 5%' },
  { value: 'used_7', label: 'с НДС 7%' },
  { value: 'not_used', label: 'без НДС' },
]

export const hiredOptions = [
  { value: 1, label: 'есть наемные водители' },
  { value: 0, label: 'нет наемных водителей' },
]

export const statutoryCommonOptions = {
  passport: 'Паспорт руководителя 2-3 стр, прописка',
  account: 'Расчетный счет',
  tax_form: 'Документ о форме налогообложения (письмо о применении НДС)',
  form_knd_1110058: 'Форма по КНД 1110058',
  nds_last_quarter: 'Декларация НДС за последний квартал',
  personal_data_or_efs_1: 'Персонифицированные сведения о физ лицах или ЕФС-1',
}

export const statutoryIndividualOptions = {
  egr: 'ОГРНИП',
  ogrn: 'ЕГРИП',
}

export const statutoryOrganizationOptions = {
  egr: 'ЕГРЮЛ',
  ogrn: 'ОГРН',
  statutory_docs: 'Уставные документы',
}
